import { render, staticRenderFns } from "./confirmPayment.vue?vue&type=template&id=10c1dd00"
import script from "./confirmPayment.vue?vue&type=script&lang=js"
export * from "./confirmPayment.vue?vue&type=script&lang=js"
import style0 from "./confirmPayment.vue?vue&type=style&index=0&id=10c1dd00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports